import axios from "axios"
import { CONST_API_DASHBOARD_POST_ALERTES_CONSULTANTS_AVEC_DOCS_EMBAUCHE_NON_ENVOYES_ENDPOINT } from "../../../../../endpoints"
import { IRequestModel, IResponseModel } from "./_models"

export function getAlertesConsultantsAvecDocsEmbaucheNonEnvoyesRequest(payload: IRequestModel) {
     return axios.post<IResponseModel>(CONST_API_DASHBOARD_POST_ALERTES_CONSULTANTS_AVEC_DOCS_EMBAUCHE_NON_ENVOYES_ENDPOINT, payload)
}
